import {FieldPath} from '@mintdata/mint-kit/api/properties/BindPath';
import {IPropertyConverter} from '@mintdata/mint-kit/api/properties/PropertyConverter';
import {PropertySpec, PropName} from '@mintdata/mint-kit/api/properties/PropertySpec';
import {PropertyUtils} from '@mintdata/mint-kit/api/properties/PropertyUtils';
import {BaseFieldConverter} from '@mintdata/mint-kit/impl/properties/converters/BaseFieldConverter';

export class BeanConverter<T> extends BaseFieldConverter<T>
{
    public getFieldConverter<FT = any>(fieldPath:FieldPath):IPropertyConverter<FT>
    {
        const mintProps:Array<PropertySpec<any>> = PropertyUtils.getProperties(new this.typeCtor());

        if( fieldPath )
        {
            if( fieldPath.indexOf('.') != -1 )
                throw new Error('Nested paths not supported (yet)');

            let mintProp = PropertyUtils.findPropertyByName(fieldPath as PropName, mintProps);
            if( !mintProp )
                throw new Error('Cannot find @Property annotation for fieldPath: ' + fieldPath);

            let typeConfig = mintProp.typeConfig;
            if( !typeConfig )
                throw new Error(`Cannot find @Property ${mintProp.name} is missing a converter in its typeConfig`);

            let converter = typeConfig.converter as any;
            if( !converter )
                throw new Error('Cannot find converter for fieldPath: ' + fieldPath);

            return new converter();
        }
        else
            throw new Error('Invalid bindPath (cannot be null/undefined)');
    }
}
